import { AppThunk } from '../../../store/rootReducer';
import { CHANGE_AMPLITUDE } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';
import { AnalyticsPlot } from '../types/analytics.types';

export const trackChangeAmplitude =
  (
    newAmplitude: number,
    previousAmplitude: number,
    plot: AnalyticsPlot,
    sendToAnalytics = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    sendToAnalytics({
      name: CHANGE_AMPLITUDE,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        plot,
        previous_amplitude: previousAmplitude,
        new_amplitude: newAmplitude,
      },
    });
  };
